import { Box, Card, Container, Grid, Typography, TextField, Button, Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';
import { ResponseBase } from '../../config/types';
import { LoginService } from '../../service/LoginService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TvLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [state, setState] = useState(false);
    const [disableLogin, setDisableLogin] = useState(true);
    const [device, setDevice] = useQueryParam('d', StringParam);
    const [accessToken, setAccessToken] = useQueryParam('t', StringParam);
    const [deviceValue, setDeviceValue] = useState('');


    const login = async (username: string, password: string) => {
        console.log("login request")
        if (username.length < 5) {
            toast("用户名长度不少于5位");
            return;
        }
        if (password.length < 6) {
            toast("密码长度不少于6位");
            return;
        }
        // console.log("登录成功")
        const loginService = new LoginService();

        const r = await loginService.verifyTokenWithUserInfo(deviceValue, username, password);
        const res: ResponseBase = r.data;
        if(res.code == 1){
            setState(true);
        }else{
            toast(res.info)
        }
        
    }

    const changeTempAccessTokenState = async (device: string) => {
        const loginService = new LoginService();
        const r = await loginService.changeTempAccessTokenState(device, 'login');
        const res: ResponseBase = r.data;
        console.log(res)
    }

    useEffect(() => {
        if (!device) {
            setDeviceValue("设备号获取失败，无法授权");
            setDisableLogin(true);
        } else {
            setDeviceValue(device)
            changeTempAccessTokenState(device);
            setDisableLogin(false)
        }
    },[])

    return (
        <Container maxWidth="xs">
            <ToastContainer/>
            {!state ? (
                <Box
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { width: '100%', marginBottom: '20px' },
                    }}
                    noValidate
                    autoComplete="off">
                    <Typography variant="h6" component="h6" align='center' padding={2} marginBottom={'20px'}>
                        花儿和马嗒设备登录授权
                    </Typography>
                    <div>
                        <TextField
                            disabled
                            label="授权设备号"
                            value={deviceValue}
                        />
                        <TextField
                            required
                            id="outlined-required"
                            label="用户名"
                            placeholder="请输入6-12位用户名"
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value)
                            }}
                        />
                        <TextField
                            required
                            id="outlined-required"
                            label="密码"
                            type={'password'}
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value)
                            }}
                        />
                        <div style={{ marginTop: '30px' }}></div>
                        <Button variant={'contained'} size={'large'} style={{ width: '100%' }} onClick={() => { login(username, password) }} disabled={disableLogin}>确认登录授权</Button>
                    </div>
                </Box>
            ) : (
                <Box style={{ padding: '30px' }}>
                    <Alert severity="success">
                        授权成功，请在App中确认
                    </Alert>

                </Box>
            )}



        </Container>
    );
}
export default TvLogin;